"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
exports.getSearch = getSearch;
exports.getSuburb = getSuburb;
exports.loadSuburbs = loadSuburbs;
var _objectSpread7 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _utils = require("./utils");
var _createMappedReducer;
var LOADING_SUBURBS = 'rw-office/suburbs/LOADING_SUBURBS';
var LOADED_SUBURBS = 'rw-office/suburbs/LOADED_SUBURBS';
var NOT_FOUND_SUBURBS = 'rw-office/suburbs/NOT_FOUND_SUBURBS';
var initialState = (0, _freeze["default"])({
  entities: {},
  searches: {}
});
var DEFAULT_SUBURB = (0, _freeze["default"])((0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, _utils.DEFAULT_LOADABLE), {}, {
  id: undefined
}));
var DEFAULT_SEARCH = (0, _freeze["default"])((0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, _utils.DEFAULT_LOADABLE), {}, {
  items: [],
  totalResults: undefined
}));
var markIfNotFoundPage = function markIfNotFoundPage(entities, ids) {
  var dirty = false;
  var next = (0, _objectSpread7["default"])({}, entities);
  (0, _forEach["default"])(ids).call(ids, function (id) {
    var entity = entities[id];
    if (entity && !entity.loading) {
      return;
    }
    dirty = true;
    next[id] = (0, _objectSpread7["default"])((0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, DEFAULT_SUBURB), entity), {}, {
      loading: false,
      loaded: true,
      notFound: true
    });
  });
  return dirty ? next : entities;
};
var reduceLoadingSuburbs = function reduceLoadingSuburbs(state, _ref) {
  var _objectSpread3, _objectSpread4;
  var key = _ref.key,
    page = _ref.page,
    ids = _ref.ids;
  // Mark entities as loading if not already present
  var entities = !ids.length ? state.entities : (0, _reduce["default"])(ids).call(ids, function (result, id) {
    var _objectSpread2;
    var entity = result[id];
    if (entity) return result;
    return (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, result), {}, (_objectSpread2 = {}, _objectSpread2[id] = (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, DEFAULT_SUBURB), {}, {
      loading: true
    }), _objectSpread2));
  }, state.entities);
  return (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state), {}, {
    entities: entities,
    searches: (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state.searches), {}, (_objectSpread4 = {}, _objectSpread4[key] = (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state.searches[key]), {}, (_objectSpread3 = {}, _objectSpread3[page] = (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, DEFAULT_SEARCH), {}, {
      loading: true
    }), _objectSpread3)), _objectSpread4))
  });
};
var normalise = function normalise(_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
    _ref2$results = _ref2.results,
    results = _ref2$results === void 0 ? [] : _ref2$results,
    _ref2$totalResults = _ref2.totalResults,
    totalResults = _ref2$totalResults === void 0 ? 0 : _ref2$totalResults;
  return (0, _reduce["default"])(results).call(results, function (previous, current) {
    /* eslint-disable no-param-reassign */
    previous.entities[current.id] = (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, current), {}, {
      loading: false,
      loaded: true
    });
    previous.items.push(current.id);
    /* eslint-enable no-param-reassign */
    return previous;
  }, {
    entities: {},
    items: [],
    totalResults: totalResults
  });
};
var reduceLoadedSuburbs = function reduceLoadedSuburbs(state, action) {
  var _objectSpread5, _objectSpread6;
  var key = action.key,
    page = action.page,
    ids = action.ids,
    data = action.data,
    error = action.error;
  var _normalise = normalise(data),
    entities = _normalise.entities,
    items = _normalise.items,
    totalResults = _normalise.totalResults;
  return (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state), {}, {
    entities: markIfNotFoundPage((0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state.entities), entities), ids),
    searches: (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state.searches), {}, (_objectSpread6 = {}, _objectSpread6[key] = (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state.searches[key]), {}, (_objectSpread5 = {}, _objectSpread5[page] = (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, DEFAULT_SEARCH), {}, {
      items: items,
      loaded: true,
      loading: false,
      error: error,
      totalResults: totalResults
    }), _objectSpread5)), _objectSpread6))
  });
};
var reduceNotFoundPageSuburbs = function reduceNotFoundPageSuburbs(state, _ref3) {
  var ids = _ref3.ids;
  var entities = markIfNotFoundPage(state.entities, ids);

  // Avoid modifying state if no changes actually made
  return entities === state.entities ? state : (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, state), {}, {
    entities: entities
  });
};
var reducer = (0, _utils.createMappedReducer)((_createMappedReducer = {}, _createMappedReducer[LOADING_SUBURBS] = reduceLoadingSuburbs, _createMappedReducer[LOADED_SUBURBS] = reduceLoadedSuburbs, _createMappedReducer[NOT_FOUND_SUBURBS] = reduceNotFoundPageSuburbs, _createMappedReducer), initialState);
var _default = exports["default"] = reducer;
/**
 * Syncronously notify the store that a set of suburbs are being
 * fetched.
 *
 * @param {String} key, the stringified query
 * @param {String} page, the page number
 *
 * @return {Void}
 */
function loadingSuburbs(key, page, ids) {
  return {
    type: LOADING_SUBURBS,
    key: key,
    page: page,
    ids: ids
  };
}
function loadedSuburbs(key, page, ids, data, _temp2) {
  var _ref4 = _temp2 === void 0 ? {} : _temp2,
    _ref4$error = _ref4.error,
    error = _ref4$error === void 0 ? false : _ref4$error;
  return {
    type: LOADED_SUBURBS,
    key: key,
    page: page,
    ids: ids,
    data: data,
    error: error
  };
}
var notFoundSuburbs = function notFoundSuburbs(ids) {
  return {
    type: NOT_FOUND_SUBURBS,
    ids: ids
  };
};

/**
 * Should a network request be performed given what the store
 * currently knows about the suburbs?
 *
 * @param {Object} state
 * @param {String} key, the stringified query
 * @param {String} page, the page number
 *
 * @return {Boolean} shouldLoadSuburbs?
 */
function shouldLoadSuburbs(state, key, page) {
  var search = state.searches[key];

  // search key doesn't exist
  if (!search || !search[page]) {
    return true;
  }

  //  same request is in flight
  if (search[page].loading || search[page].loaded) {
    return false;
  }
  return true;
}

/**
 * Retrieve a suburb given an id.
 *
 * @param {Object} store.getState() (or suburb object if reducers are combined)
 */
function getSuburb(state, id) {
  return state.entities[id] || (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, DEFAULT_SUBURB), {}, {
    id: id
  });
}

/**
 * Access the contents of a previous search using current state (suburbs), the
 * query object and page. In order to retreive all the pages for a given query,
 * `-1` can be passed as the page number.
 *
 * @param {Object} - store.getState() (or suburbs object if reducers are combined)
 * @param {Object} - the query object used to retrieve the suburbs
 * @param {String|Integer} - the page number or `-1` for all suburbs
 *
 * @return {Object} - the search page (or pages) and associated entities.
 */
function getSearch(state, query, page) {
  var _context2;
  if (page === void 0) {
    page = 1;
  }
  var searches = state.searches,
    entities = state.entities;
  var key = (0, _utils.keystringify)(query);
  var search = searches[key];
  if (!search) {
    return DEFAULT_SEARCH;
  }
  var meta;
  if (page === -1) {
    // Get *all* pages in the store
    var keys = (0, _keys["default"])(search);
    meta = (0, _reduce["default"])(keys).call(keys, function (result, _page) {
      var _context;
      var _search$_page = search[_page],
        items = _search$_page.items,
        totalResults = _search$_page.totalResults,
        loaded = _search$_page.loaded,
        loading = _search$_page.loading,
        error = _search$_page.error;

      /* eslint-disable no-param-reassign */
      result.items = (0, _concat["default"])(_context = result.items).call(_context, items);
      result.totalResults = result.totalResults || totalResults;
      result.loaded = result.loaded && loaded;
      result.loading = result.loading || loading;
      result.error = result.error || error;
      /* eslint-enable no-param-reassign */

      return result;
    }, (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, DEFAULT_SEARCH), {}, {
      loaded: !!keys.length
    }));
  } else {
    // Get a specific page in the store
    if (!search[page] || !search[page].items) {
      return DEFAULT_SEARCH;
    }
    meta = search[page];
  }
  return (0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, meta), {}, {
    items: (0, _map["default"])(_context2 = meta.items).call(_context2, function (item) {
      return entities[item];
    })
  });
}

/**
 * Load suburbs.
 *
 * @param {Function} api The function to load data with.
 * @param {Object} query The query to run.
 * @param {Number} page The page number to load.
 * @param {Array} ids Specific IDs of suburbs to load; marked as loading and
 *        then as not found if they're not included in the final result set.
 */
function loadSuburbs(api, search, page, ids) {
  if (page === void 0) {
    page = 1;
  }
  if (ids === void 0) {
    ids = [];
  }
  return function (dispatch, getState) {
    var _getState = getState(),
      suburbs = _getState.suburbs;
    var from = (search.size || 10) * (page - 1);
    var key = (0, _utils.keystringify)(search);
    if (!shouldLoadSuburbs(suburbs, key, page)) {
      dispatch(notFoundSuburbs(ids));
      return _promise["default"].resolve(getSearch(suburbs, search, page));
    }
    dispatch(loadingSuburbs(key, page, ids)); // notify store
    return api((0, _objectSpread7["default"])((0, _objectSpread7["default"])({}, search), {}, {
      from: from
    })).then(function (data) {
      return dispatch(loadedSuburbs(key, page, ids, data));
    })["catch"](function (error) {
      return dispatch(loadedSuburbs(key, page, ids, undefined, {
        error: error
      }));
    }).then(function () {
      return getSearch(getState().suburbs, search, page);
    });
  };
}